export default defineNuxtPlugin(() => {
  if (typeof window === 'undefined') return

  // Helper to wait for the element to be in the DOM
  function waitForElement(selector, callback) {
    const el = document.querySelector(selector)
    if (el) {
      callback(el)
    } else {
      const observer = new MutationObserver(() => {
        const el = document.querySelector(selector)
        if (el) {
          observer.disconnect()
          callback(el)
        }
      })
      observer.observe(document.body, { childList: true, subtree: true })
    }
  }

  // Define the global callback for the Google Translate script
  window.googleTranslateElementInit = () => {
    waitForElement('#google_translate_element', () => {
      new window.google.translate.TranslateElement(
        {
          pageLanguage: 'en',
          includedLanguages: 'en,es,zh-TW',
          layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
          autoDisplay: false,
        },
        'google_translate_element'
      )
    })
  }

  // Inject the Google Translate script
  const script = document.createElement('script')
  script.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit'
  script.async = true
  document.head.appendChild(script)
})


// export default defineNuxtPlugin(() => {
//   if (typeof window === 'undefined') return

//   // Define the global callback for the Google Translate script
//   window.googleTranslateElementInit = () => {
//     new window.google.translate.TranslateElement(
//       {
//         pageLanguage: 'en',
//         includedLanguages: 'en,es,zh-TW',
//         layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
//         autoDisplay: false,
//       },
//       'google_translate_element'
//     )
//   }

//   // Inject the Google Translate script
//   const script = document.createElement('script')
//   script.src =
//     'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit'
//   script.async = true
//   document.head.appendChild(script)
// })
